export class blogDetailDB {
    static Details =
        {
            date:'July, 24th 2018',
            title:'Sandford Stadium Improvements',
            detail1:'Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting,remaining essentially unchanged.It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
            detail2:'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
            name:'Mark jkcno',
            like:'10',
            comment:', 50',
            section:'Comments :',
            commentSection:[
                {
                    Id:1,
                    commentImg:'assets/images/app_landing2/team/1.png',
                    commentName:'That Guy',
                    commentDate:'Dec 16,2014',
                    commentDescription:'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                    commentReplayTag:'reply'        
                },
                {
                    Id:2,
                    commentImg:'assets/images/app_landing2/team/2.png',
                    commentName:'That Guy',
                    commentDate:'Dec 16,2014',
                    commentDescription:'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                    commentReplayTag:'reply'        
                },
                {
                    Id:3,
                    commentImg:'assets/images/app_landing2/team/3.png',
                    commentName:'That Guy',
                    commentDate:'Dec 16,2014',
                    commentDescription:'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                    commentReplayTag:'reply'        
                },
                {
                    Id:4,
                    commentImg:'assets/images/app_landing2/team/4.png',
                    commentName:'That Guy',
                    commentDate:'Dec 16,2014',
                    commentDescription:'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                    commentReplayTag:'reply'        
                }

            ]
            
        }
    }